/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import customStyles from "../../../assets/styles/customStyles";
import MainHeader from "../../Shared/components/Header";
import { Row, Col } from "antd";
import Menus from "./Menus";
import ProductIcon from "../../../assets/images/icon_menus/ProductIcon.json";
import { useDispatch, useSelector } from "react-redux";
import { BestSellingProducts, TopProductSupply, ProductLocation, SalesByProduct, NoData } from "../../Shared/components/Dashboard";
import action from "./redux/actions";
import { checkModuleViewPermission } from '../../../helpers/utilities';
import { storageGetItem } from '../../../helpers/utilities';

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
    Navigation,
    Pagination,
    Autoplay,
    Virtual
} from "swiper/core";


SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);

const ProductDashboard = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { productDashboardDetails } = useSelector(state => state.productDashboardReducer);
    const [height, setHeight] = useState(300);
    const [menuHeight, setMenuHeight] = useState(0);
    const leftRef = useRef('');
    const { history } = props;
    const dispatch = useDispatch();


    const calculateHeight = () => {
        if (document.querySelectorAll(`.menuCheck`).length > 0) {
            if (leftRef && leftRef?.current)
                setMenuHeight(leftRef.current.offsetHeight + 25);
            if (document.querySelectorAll(`.${classes.primaryMenu}`) && document.querySelectorAll(`.${classes.primaryMenu}`).length > 0 && leftRef.current) {
                let height = document.querySelectorAll(`.${classes.primaryMenu}`)[0].offsetHeight;
                let offsetHeight = leftRef?.current?.offsetHeight + height + 23;
                setHeight(offsetHeight);
            }
        }
    }


    useEffect(() => {
        if (roleManagement !== '') {
            if (checkModuleViewPermission('Product', history)) {
                loadTasks();
                setTimeout(() => {
                    calculateHeight();
                }, 100);
            }
        }
    }, [roleManagement]);


    const loadTasks = useCallback(() => {
        dispatch({ type: action.PRODUCT_DASHBOARD_START, url: 'productDashBoard' });
    });

    const classes = customStyles();

    return (
        <React.Fragment>
            <MainHeader {...props} img={ProductIcon} title={'Product'} links={[{ 'label': 'Home', 'link': '/' }, { 'label': 'Product', 'link': '' }]} close={false} />
            <div className={clsx(classes.listTableMargin, classes.containerBorder, classes.cardEHeight)}>
                <Row gutter={25} className={classes.dashboardRow}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={16} xxl={16}>
                        <Row gutter={25} ref={leftRef}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {/* <Image src={underConstruction} preview={false} /> */}
                                        {
                                            productDashboardDetails !== undefined && productDashboardDetails !== '' ? <>
                                                {
                                                    productDashboardDetails?.currenMonth_topSaled_product && productDashboardDetails?.currenMonth_topSaled_product?.length > 0 ? <SalesByProduct title="Total Sales By Product - Current Month"
                                                        value={productDashboardDetails?.curentMonthTotalSales}
                                                        quantity={productDashboardDetails?.currentMonthTotalSalesQuantity}
                                                        details={productDashboardDetails?.currenMonth_topSaled_product}
                                                        subTitle={'Current'} /> : <NoData />
                                                }
                                            </> : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} className={classes.secondBox}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {/* <Image src={underConstruction} preview={false} /> */}
                                        {
                                            productDashboardDetails !== undefined && productDashboardDetails !== '' ? <>
                                                {
                                                    productDashboardDetails?.previousMonth_topSaled_product && productDashboardDetails?.previousMonth_topSaled_product?.length > 0 ?
                                                        <SalesByProduct title="Total Sales By Product - Previous Month"
                                                            value={productDashboardDetails?.peviousMonthTotalSales}
                                                            quantity={productDashboardDetails?.previousMonthTotalSalesQuantity}
                                                            subTitle={'Previous'}
                                                            details={productDashboardDetails?.previousMonth_topSaled_product} /> : <NoData />
                                                }
                                            </> : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {
                            roleManagement !== '' && <Menus menuHeight={menuHeight} />
                        }
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} className={classes.thirdBox}>
                        <div className={clsx(classes.boxBorderH)} style={{ height: (height) + 'px' }}>
                            {
                                productDashboardDetails !== undefined && productDashboardDetails !== '' ? <>
                                    <Swiper
                                        id="swiper"
                                        virtual
                                        autoplay={false}
                                        allowTouchMove={false}
                                        loop
                                        pagination={{ clickable: true }}>
                                        <SwiperSlide key={`slide-1`} style={{ listStyle: "none" }}>
                                            <BestSellingProducts title="Best Selling Products" details={productDashboardDetails} />
                                        </SwiperSlide>
                                        <SwiperSlide key={`slide-2`} style={{ listStyle: "none" }}>
                                            <TopProductSupply title="Top Products Supply" details={productDashboardDetails} />
                                        </SwiperSlide>
                                        {
                                            storageGetItem('businessType') === 'MANUFACTURER' &&
                                            <SwiperSlide key={`slide-3`} style={{ listStyle: "none" }}>
                                                <ProductLocation title="Best Selling Products <br/> By Location" details={productDashboardDetails} />
                                            </SwiperSlide>
                                        }
                                    </Swiper>
                                </> : <div className={classes.loadMoreCircle}></div>
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default ProductDashboard